import Vue from 'vue'
import reactiveStorage from 'vue-reactive-storage'
// Set initial values
Vue.use(reactiveStorage, {
  translations: {},
  mobile: {},
  email: {},
})
